import { JsonObject, JsonProperty, Optional } from 'json-ts-mapper';
import { CategorieArticle } from './enum-types/categorie-article';
import { CodeDomaine } from './enum-types/code-domaine';

@JsonObject
export class Article {
  constructor (
    id?: number,
    domaine?: CodeDomaine,
    numArticle?: string,
    typeArticle?: string,
    libelle?: string,
    commentaire?: string,
    categorie?: CategorieArticle
  ) {
    this.id = id as any;
    this.domaine = domaine as any;
    this.numArticle = numArticle as any;
    this.typeArticle = typeArticle as any;
    this.libelle = libelle as any;
    this.commentaire = commentaire as any;
    this.categorie = categorie as any;
  }

  @JsonProperty(Number)
  id: number;

  @JsonProperty(String)
  domaine: CodeDomaine;

  @JsonProperty(String)
  numArticle: string;

  @JsonProperty(String)
  typeArticle: string;

  @JsonProperty(String)
  libelle: string;

  @JsonProperty(String)
  @Optional
  commentaire: string;

  @JsonProperty(String)
  categorie: CategorieArticle;
}
